import { SignInPage } from './dumb.js';
import enhance from './enhancer';

export default enhance(SignInPage);
